import { Route, Routes } from 'react-router-dom';
import { GalleriesPage } from './GalleriesPage';
import { ModifyGalleryPage } from './ModifyGalleryPage';

export const GalleryPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyGalleryPage />} />
    <Route path='/:galleryID' element={<ModifyGalleryPage />} />
    <Route path='*' element={<GalleriesPage />} />
  </Routes>
);
